/**
 * Product identity. The name may change (BUILD-PLAN Q1: "Velora" may become
 * "Pulse"), so every user-visible product name must come from here.
 */
export const PRODUCT = {
  /** Full product name shown in titles, login and legal copy. */
  name: 'Velora Dental',
  /** Short name for tight chrome (collapsed nav, tab titles). */
  shortName: 'Velora',
  /** npm scope and code identifiers stay `velora` even if the brand changes. */
  codeName: 'velora',
} as const;

export type Product = typeof PRODUCT;
